/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { AnyNonRedactedAutoTestStepAsJSON } from './AnyNonRedactedAutoTestStepAsJSON';
import { CustomOutputExtra } from './CustomOutputExtra';
const CustomOutputAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(CustomOutputExtra, AnyNonRedactedAutoTestStepAsJSON);
export class CustomOutputAsJSON extends AnyNonRedactedAutoTestStepAsJSON {
    static decode(input) {
        return CustomOutputAsJSONParser.decode(input).map(res => new CustomOutputAsJSON(res));
    }
    static unsafeDecode(input) {
        return CustomOutputAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CustomOutputAsJSONParser.encode(data);
    }
    static schema() {
        return CustomOutputAsJSONParser.schema();
    }
}
